export default __webpack_public_path__ + "static/media/vps-enter-credentials.4bb6b8bd.png";